<template>
  <div class="reportList">
    <div class="filtrate">
      <div class="filtrateSelect">
        <div class="inputBox">
          <div class="label">学届：</div>
          <el-select v-model="studyYearId" @change="btn_study_year_Change()" size="mini" placeholder="请选择">
            <el-option v-for="item in btn_study_year" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </div>
        <div class="inputBox">
          <div class="label">学年：</div>
          <el-select v-model="yearValue" @change="yearListChange()" size="mini" placeholder="请选择">
            <el-option v-for="item in yearList" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </div>
        <div class="inputBox">
          <div class="label">学期：</div>
          <el-select @change="btn_study_cycle_Change()" v-model="btn_study_cycle_id" size="mini" placeholder="请选择">
            <el-option v-for="item in btn_study_cycle" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </div>
        <div class="inputBox">
          <div class="label">班级：</div>
          <el-select v-model="classId" size="mini" placeholder="请选择" @change="onChangeClass">
            <el-option v-for="item in classList" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </div>
        <div class="inputBox">
          <div class="label">状态：</div>
          <el-select v-model="status" size="mini" placeholder="请选择">
            <el-option v-for="item in statusArr" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </div>
        <div class="inputBox">
          <div class="label">幼儿：</div>
          <el-input @focus="inputFous" style="width: 193px" size="mini" v-model="studentName"
            placeholder="请输入幼儿姓名"></el-input>
        </div>
        <div class="inputBox">
          <div class="label">名称：</div>
          <el-input style="width: 193px" size="mini" v-model="reportName" placeholder="请输入报告名称"></el-input>
        </div>
        <div class="inputBox">
          <div class="label"> </div>
          <el-button size="mini" style="
          border-color: #5474e6;
          background: #5474e6;
          align-self: flex-start;
        " type="primary" class="btn" @click="ClearFrom">清空筛选</el-button>
          <el-button size="mini" style="
          border-color: #5474e6;
          background: #5474e6;
          align-self: flex-start;
        " type="primary" class="btn" @click="WebGrowStudentList">查询</el-button>
        </div>
      </div>

    </div>
    <div class="reportListBox">
      <el-button size="mini" style="
          border-color: #5474e6;
          background: #5474e6;
          align-self: flex-start;
          margin-bottom: 15px;
        " type="primary" class="btn" v-if="userInfo.UserIdentity.indexOf('2') != -1"
        @click="batchrRecord">批量评价</el-button>
      <el-button size="mini" style="
          border-color: #5474e6;
          background: #5474e6;
          align-self: flex-start;
          margin-bottom: 15px;
        " type="primary" class="btn" @click="autoReport">生成报告</el-button>
      <el-button size="mini" style="
          border-color: #5474e6;
          background: #5474e6;
          align-self: flex-start;
          margin-bottom: 15px;
        " type="primary" class="btn" @click="downReport">下载生成的报告</el-button>
      <el-table :header-cell-style="{
            background: '#F2F5FF',
          }" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="TempType" label="学年" width="180">
        </el-table-column>
        <el-table-column prop="StudyYearName" label="学届" width="180">
        </el-table-column>
        <el-table-column prop="GradeName" label="年级" width="180">
        </el-table-column>
        <el-table-column prop="ClassName" label="班级"> </el-table-column>
        <el-table-column prop="StudentName" label="姓名"> </el-table-column>
        <el-table-column prop="TempTitle" label="名称"> </el-table-column>
        <el-table-column prop="ProGress" label="完成进度"> </el-table-column>
        <el-table-column prop="Status" label="完成状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.Status == 1" type="success">已完成</el-tag>
            <el-tag v-else type="warning">未完成</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作">
          <template slot-scope="scope">
            <!-- #999999 v-if="scope.row.Status == 1"-->
            <el-button size="mini" style="color: #5474e6" type="text" v-if="scope.row.OverCount >= 1"
              @click="lookReport(scope.$index, scope.row)">查看报告</el-button>
            <el-button v-if="userInfo.UserIdentity.indexOf('2') != -1" size="mini" style="color: #5474e6" type="text"
              @click="Record(scope.row)">去记录</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="PageSizeChange" :current-page="PageIndex"
          :page-sizes="[10, 20, 30, 40, 60, 80, 100]" :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="dataCount"
          style="text-align: center;padding:20px;">
        </el-pagination>
      </div>
    </div>

    <!--  -->
    <el-dialog title="批量评价" :visible.sync="addDialogVisible" width="50%">
      <div style="padding: 0 0 10px 30px; color: red">
        若没有数据时,请先筛选学届，年级，班级进行批量评价哦~
      </div>
      <div>
        <div class="inputBox">
          <div class="label">模板：</div>
          <!-- /    -->
          <el-select @change="tempChange" v-model="batchrRecordFrom.tempId" size="mini" placeholder="请选择">
            <el-option v-for="item in templateGrowingList" :key="item.Id" :label="item.Title" :value="item.Id">
            </el-option>
          </el-select>
        </div>
        <div class="inputBox">
          <!--  @change="typeChange" -->
          <div class="label">主题：</div>
          <el-select @change="templateGrowingChange" v-model="batchrRecordFrom.tempDetailId" size="mini"
            placeholder="请选择">
            <el-option v-for="item in templateGrowingChildList" :key="item.Id" :label="item.Title" :value="item.Id">
            </el-option>
          </el-select>
        </div>
        <div class="inputBox">
          <div class="label">选择学生：</div>
          <!--   @change="typeChange" -->
          <el-select v-model="batchrRecordFrom.customerIds" size="mini" multiple placeholder="请选择">
            <el-option v-for="item in studentList" :key="item.Id" :label="item.StudentName" :value="item.Id">
            </el-option>
          </el-select>
          <el-button style="margin-left: 10px; height: 30px" type="success" v-if="studentList.length != 0" size="mini"
            @click="checkStudentAll">全选</el-button>
          <el-button style="margin-left: 10px; height: 30px" type="warning" v-if="studentList.length != 0" size="mini"
            @click="clearStudentAll">清空</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="GoTenantTempDetailOneInfoByImgTextRecord">去评价</el-button>
      </span>
    </el-dialog>

    <!-- 去记录 -->
    <el-dialog @closed="clearAddFromRecord" :title="recordInfo.Title" :visible.sync="recordDialogVisible">
      <!-- 图文板式 视频 体检 运动 -->
      <div v-if="recordInfo.TypeNum == 6 ||
            recordInfo.TypeNum == 7 ||
            recordInfo.TypeNum == 8 ||
            recordInfo.TypeNum == 9 ||
            recordInfo.TypeNum == 1||  recordInfo.TypeNum == 10
            ">
        <record-plate @IsChange="record_plate_change" :Answer="editFrom.Answer" :PlateId="editFrom.PlateId"
          :typeNum="recordInfo.TypeNum" :Content="editFrom.Content" :title="recordInfo.Title" />
      </div>

      <!--  -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="recordDialogVisible = false">返 回</el-button>
        <el-button type="primary" @click="addFn(0)">保存草稿</el-button>
        <el-button type="primary" @click="addFn(1)">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import recordPlate from "./recordPlate.vue";
import {
  WebGrowStudentList,
  getAcademicSelect,
  GetTenantTempByPage,
  GetTenantTempDetailInfo,
  GetStudentByPage,
  GoTenantTempDetailOneInfoByImgTextRecord,
  SaveBatchDetailInfo,
  GetOpenCycleInfoSelectResult,
  GetClassSelect,
  DownMyZip,
} from "@/api/api";
export default {
  data() {
    return {
      addDialogVisible: false,
      recordDialogVisible: false,
      reportName: "",
      scopeValue: "",
      scopeList: [],
      typeNum: 0,
      btn_study_year: [], //学届数组
      yearList: [], //年份列表
      yearValue: "",
      tableData: [],
      dataCount: 0,
      classList: [],
      studyYearId: "", //学届id
      classId: "", //班级Id
      btn_study_cycle: [], //学期数组
      // className: "", //班级名称
      // gradeName: "", //年级名称
      studentName: "", //学生姓名
      status: "", //状态
      btn_study_cycle_id: "", //学期Id
      PageIndex: 1, // 分页
      PageSize: 20,
      name: "", // 成长足迹名称
      statusArr: [
        {
          Name: "未完成",
          Id: 2,
        },
        {
          Name: "已完成",
          Id: 1,
        },
      ],
      templateGrowingList: [], //成长足迹列表
      templateGrowingChildList: [], //成长足迹子模块列表
      studentList: [], //学生列表
      batchrRecordFrom: {
        tempId: "",
        tempDetailId: "",
        answer: "",
        teacherId: 0,
        customerIds: [],
        type: 1,
        isWeb: 1,
      },
      userInfo: {},
      getStudentFrom: {
        GradeName: "",
        ClassName: "",
      },
      recordInfo: {
        Title: "",
        TypeNum: 0,
      },
      editFrom: {
        Content: "",
        BackCoverImg: "",
        Answer: "",
        PlateId: "",
      }, //去记录参数
      isKindergarten: false,
      GradeId: "", //年级id
      multipleSelection: [],
    };
  },

  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    //console.log(!this.userInfo.UserIdentity.includes("1"));
    let UserIdentityArr = this.userInfo.UserIdentity.split(";");
    let isKindergarten = UserIdentityArr.find((item) => {
      return item == 1;
    });
    if (isKindergarten) {
      this.isKindergarten = true;
    } else {
      this.isKindergarten = false;
    }
    this.WebGrowStudentList();
    this.getYearList();
    this.getAcademicSelectList();
    this.batchrRecordFrom.teacherId = this.userInfo.uID;
  },
  components: {
    recordPlate,
  },
  methods: {
    autoReport() {
      let arr = [];
      //
      //  //console.log(a, "this.multipleSelection");
      if (
        this.multipleSelection.length > 0 &&
        this.multipleSelection.filter((x) => x.OverCount > 0).length > 0
      ) {
        arr = this.multipleSelection.filter((x) => x.OverCount > 0);
        //console.log(arr, "arr");
        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          let info = {
            TeacherId: element.TecherId,
            TempId: element.TempId,
            CustomerId: element.StudentId,
            TempType: element.TempType,
            CycleName: element.CycleName,
            StudentName: element.StudentName,
          };
          const href = this.$router.resolve({
            path: "/growingFootprintReport",
            query: {
              info: escape(JSON.stringify(info)),
              Type: 1,
              Num: index,
            },
          });
          //console.log(href, "href");
          window.open(href.href, "_blank");
        }
      } else {
        this.$message.warning("请选择最少完成1个的成长记录进行生成");
      }
    },
    downReport() {
      DownMyZip({ Id: 0 }).then((res) => {
        //console.log(res);
        if (res.data.success) {
          window.open("http://pdffile.mushroomisland.cn" + res.data.response);
        } else {
          this.$message({
            type: "error",
            message: "失败",
            offset: 110,
          });
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      //console.log(val);
    },
    onChangeClass(e) {
      this.getStudentList();
      this.WebGrowStudentList();
    },
    ClearFrom() {
      this.studyYearId = "";
      this.yearValue = "";
      this.classId = "";
      this.status = "";
      this.btn_study_cycle_id = "";
      this.studentName = "";
      this.reportName = "";
      this.btn_study_cycle = [];
    },
    lookReport(index, item) {
      let info = {
        TeacherId: item.TecherId,
        TempId: item.TempId,
        CustomerId: item.StudentId,
        TempType: item.TempType,
        CycleName: item.CycleName,
        StudentName: item.StudentName,
      };
      const href = this.$router.resolve({
        path: "/growingFootprintReport",
        query: {
          info: escape(JSON.stringify(info)),
          Type: 0,
        },
      });
      window.open(href.href, "_blank");
    },
    downlookReport(index, item) {
      let info = {
        TeacherId: item.TecherId,
        TempId: item.TempId,
        CustomerId: item.StudentId,
        TempType: item.TempType,
        CycleName: item.CycleName,
        StudentName: item.StudentName,
      };
      const href = this.$router.resolve({
        path: "/growingFootprintReport",
        query: {
          info: escape(JSON.stringify(info)),
          Type: 1,
        },
      });
      window.open(href.href, "_blank");
    },
    async addFn(status) {
      if (!this.batchrRecordFrom.answer) {
        this.$message.warning("请填写成长足迹记录");
        return;
      }
      this.batchrRecordFrom.Status = status;
      let xhr = await SaveBatchDetailInfo(this.batchrRecordFrom);
      if (xhr.data.success) {
        this.editFrom.Answer = "";
        this.recordDialogVisible = false;
        // this.WriteTempDetailList();
        this.$message.success("保存成功");
      } else {
        if (xhr.data.response == 401) {
          this.$confirm('！！！此模块之前数据将丢失，此操作将强制覆盖此模块, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {

            //进行强制覆盖操作
            this.batchrRecordFrom.IsManage = 1;
            let xhr2 = await SaveBatchDetailInfo(this.batchrRecordFrom);
            if (xhr2.data.success) {
              this.editFrom.Answer = "";
              this.recordDialogVisible = false;
              // this.WriteTempDetailList();
              this.$message({
                type: 'success',
                message: '成功!'
              });

            }

          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        } else {
          this.$message.error(xhr.data.msg);
        }

      }
    },
    record_plate_change(e) {
      this.batchrRecordFrom.answer = JSON.stringify(e);
    },

    async GoTenantTempDetailOneInfoByImgTextRecord() {
      if (!this.batchrRecordFrom.teacherId) {
        this.$message.warning("请选择模板");
        return;
      }
      if (!this.batchrRecordFrom.teacherId) {
        this.$message.warning("请选择主题");
        return;
      }
      if (this.batchrRecordFrom.customerIds.length == 0) {
        this.$message.warning("请选择学生");
        return;
      }
      this.addDialogVisible = false;
      this.recordDialogVisible = true;
      let xhr = await GoTenantTempDetailOneInfoByImgTextRecord({
        Id: this.batchrRecordFrom.tempDetailId,
        StudentId: this.batchrRecordFrom.customerIds[0],
      });
      if (xhr.data.success) {
        this.editFrom.Content = xhr.data.response.Content;
        this.editFrom.BackCoverImg = xhr.data.response.BackCoverImg;
        // this.editFrom.Answer = xhr.data.response.Answer;
        this.editFrom.Answer = "";
        this.editFrom.PlateId = xhr.data.response.PlateId;
      } else {
        this.editFrom = {
          Content: "",
          BackCoverImg: "",
          Answer: "",
          PlateId: "",
        };
        this.$message.error(xhr.data.msg);
      }
    },
    templateGrowingChange(value) {
      this.recordInfo = this.templateGrowingChildList.find((item) => {
        return item.Id == value;
      });
      this.batchrRecordFrom.type = this.recordInfo.TypeNum;
    },
    clearAddFromRecord() {
      this.clearAddFrom();
    },
    clearStudentAll() {
      this.batchrRecordFrom.customerIds = [];
    },
    checkStudentAll() {
      this.batchrRecordFrom.customerIds = [];
      this.studentList.forEach((item) => {
        this.batchrRecordFrom.customerIds.push(item.Id);
      });
    },
    tempChange(value) {
      let obj = this.templateGrowingList.find((item) => {
        return item.Id == value;
      });
      //console.log(obj, "ssssssss");
      if (obj) {
        this.getStudentFrom.GradeName = obj.GradeName;
        this.getStudentFrom.ClassName = obj.ClassName;
        this.getStudentList();
        this.getTemplateGrowingChildList();
      }
    },
    clearAddFrom() {
      this.batchrRecordFrom = {
        tempId: "",
        tempDetailId: "",
        answer: "",
        teacherId: "",
        customerIds: [],
        type: 1,
        isWeb: 1,
      };
      this.batchrRecordFrom.teacherId = this.userInfo.uID;
    },
    // 获取学生列表
    async getStudentList() {
      //console.log(this.userInfo, " this.userInfo");
      let xhr = await GetStudentByPage({
        SchoolId: this.userInfo.SchoolId,
        StudyYearId: this.studyYearId ? this.studyYearId : 0,
        GradeId: this.GradeId,
        ClassId: this.classId,
        PageIndex: 1,
        PageSize: 100000,
        Uid: this.userInfo.uID,
      });
      if (xhr.data.success) {
        this.studentList = xhr.data.response.data;
      } else {
        this.studentList = [];
      }
    },

    // 获取成长足迹列表
    async getTempList() {
      let obj = this.classList.find((item) => {
        return item.Id == this.classId;
      });
      //console.log(obj, "obj");
      let params = {
        PageIndex: this.PageIndex,
        PageSize: 100,
        Status: 1,
        StudyYearId: this.studyYearId ? this.studyYearId : 0,
        Year: this.yearValue ? this.yearValue : undefined,
        classId: this.classId ? this.classId : undefined,
        ClassName: obj ? obj.ClassName : undefined,
        GradeName: obj ? obj.GradeName : undefined,
        CycleId: this.btn_study_cycle_id == "" ? 0 : this.btn_study_cycle_id,
        GradeId: this.GradeId == "" ? 0 : this.GradeId,
      };

      let xhr = await GetTenantTempByPage(params);
      if (xhr.data.success) {
        this.templateGrowingList = xhr.data.response.data;

        this.batchrRecordFrom.tempId = xhr.data.response.data[0].Id;
        this.templateGrowingChildList = [];
        this.studentList = [];
        this.getStudentList();
        this.getTemplateGrowingChildList();
      } else {
        this.templateGrowingList = [];
      }
    },
    /**
     *获取子模板
     */

    async getTemplateGrowingChildList() {
      let xhr = await GetTenantTempDetailInfo({
        id: this.batchrRecordFrom.tempId,
      });
      if (xhr.data.success) {
        xhr.data.response = xhr.data.response.sort(function (a, b) {
          return a.OrderSort - b.OrderSort;
        });
        this.templateGrowingChildList = xhr.data.response.filter((item) => {
          return (
            (item.TypeNum == 6 || item.TypeNum == 9 || item.TypeNum == 10) &&
            item.Status == 1
          );
        });

        if (this.templateGrowingChildList.length > 0) {
          this.recordInfo = this.templateGrowingChildList[0];
          this.batchrRecordFrom.tempDetailId =
            this.templateGrowingChildList[0].Id;
        }
        this.batchrRecordFrom.type = this.recordInfo.TypeNum;
      } else {
        this.templateGrowingChildList = [];
      }
    },

    batchrRecordAffirm() { },
    batchrRecord() {
      this.addDialogVisible = true;
    },
    // 去记录
    Record(item) {
      //console.log(item);
      let info = {
        CustomerId: item.StudentId,
        StudentName: item.StudentName,
        TeacherId: item.TecherId,
        TempId: item.TempId,
        CycleId: item.CycleId,
        GradeName: item.GradeName,
        ClassName: item.ClassName,
        StudyYearId: item.StudyYearId,
        TempType: item.TempType,
        CycleName: item.CycleName,
      };
      this.$router.push({
        path: "/record",
        query: { info: escape(JSON.stringify(info)) },
      });
    },
    inputFous() {
      // this.studyYearId = "";
      // this.yearValue = "";
      // this.btn_study_cycle_id = "";
      // this.classId = "";
      // this.status = "";
    },
    //
    yearListChange() {
      this.studyYearId = "";
      this.btn_study_cycle = [];
      this.btn_study_cycle_id = null;
      this.classList = [];
      this.classId = null;
    },
    btn_study_year_Change() {
      this.yearValue = "";
      this.getCycleSelect(this.studyYearId);
    },
    // 获取学届
    async getAcademicSelectList() {
      let res = await getAcademicSelect({
        Uid: this.userInfo.uID,
        SchoolId: this.userInfo.SchoolId,
        Type: this.isKindergarten ? 3 : 2, //EvaluationType==2 1学生、2教师、3校长、4家长
      });
      if (res.data.success) {
        this.btn_study_year = res.data.response;
        // this.studyYearId = this.btn_study_year[0].Id;
        // this.getCycleSelect(this.btn_study_year[0].Id);
      } else {
        this.btn_study_year = [];
        this.studyYearId = [];
      }
    },
    btn_study_cycle_Change() {
      let obj = this.btn_study_cycle.find((item) => {
        return item.Id == this.btn_study_cycle_id;
      });
      this.GradeId = obj.GradeId;
      this.getClassList();
    },
    // 获取年份列表
    getYearList() {
      this.yearList = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear() + 3;
      for (let index = 6; index >= 0; index--) {
        this.yearList.push({
          Id: year - index,
          Name: year - index,
        });
      }
    },
    // 获取学期列表
    async getCycleSelect() {
      let xhr = await GetOpenCycleInfoSelectResult({
        SchoolId: this.userInfo.SchoolId,
        StudyYearsId: this.studyYearId,
      });
      if (xhr.data.success) {
        this.btn_study_cycle = xhr.data.response;
        // this.btn_study_cycle_id = xhr.data.response[0].Id;
        // this.GradeId = xhr.data.response[0].GradeId;
        // if (this.btn_study_cycle.length) {
        //   this.getClassList();
        // }
      } else {
        this.btn_study_cycle = [];

        this.$message.warning(xhr.data.msg);
      }
    },
    async getClassList(CycleId, GradeName) {
      let xhr = await GetClassSelect({
        StudyYearId: this.studyYearId,
        SchoolId: this.userInfo.SchoolId,
        GradeId: this.GradeId, //EvaluationType==2 1学生、2教师、3校长、4家长
      });
      if (xhr.data.success) {
        this.classList = xhr.data.response;
        this.classId = xhr.data.response[0].Id;
        this.WebGrowStudentList();
        this.getTempList();
      } else {
        this.classList = [];
        this.classId = "";
        this.$message.warning(xhr.data.msg);
      }
    },
    PageSizeChange(e) {
      this.PageIndex = e;
      this.WebGrowStudentList();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.WebGrowStudentList();
    },
    // 获取成长足迹列表
    async WebGrowStudentList() {
      let obj = this.classList.find((item) => {
        return item.Id == this.classId;
      });
      let xhr = await WebGrowStudentList({
        studyYearId: this.studyYearId ? this.studyYearId : undefined,
        Year: this.yearValue ? this.yearValue : undefined,
        classId: this.classId ? this.classId : undefined,
        className: obj ? obj.ClassName : undefined,
        gradeName: obj ? obj.GradeName : undefined,
        status: this.status ? this.status : undefined,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        StudentName: this.studentName ? this.studentName : undefined,
        name: this.reportName ? this.reportName : undefined,
      });
      if (xhr.data.success) {
        this.tableData = xhr.data.response.data;
        this.dataCount = xhr.data.response.dataCount;
      } else {
        this.tableData = [];
      }
    },
  },
};
</script>

<style lang="less" scoped>
.inputBox {
  display: flex;
  margin-bottom: 15px;

  .label {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    // width: 90px;
    padding-left: 30px;
    text-align: right;
  }
}

.filtrate {
  display: flex;

  background-color: #fff;
  min-height: 137px;
  margin-bottom: 10px;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: space-between;
  box-sizing: border-box;

  .filtrateSelect {
    display: flex;
    flex-wrap: wrap;

    flex: 1;
  }
}

.reportListBox {
  background-color: #fff;
  min-height: 300px;
  padding: 17px 22px;
  box-sizing: border-box;
}

.pagination {
  margin-top: 30px;
}

/* 15738996700 */
</style>